var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-map-wrapper"},[_c('div',{ref:"map-wrapper",staticClass:"space-map"},[_c('div',{staticClass:"space-map-inner"}),_vm._v(" "),_vm._t("map-ele")],2),_vm._v(" "),_c('div',{staticClass:"space-map-toolbar"},[_vm._t("toolbar")],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2237af72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpaceMap/index.vue
// module id = null
// module chunks = 